<template>
  <div>
    <a-modal
      v-model="visible"
      :loading="loading"
      title="Notice Details"
      :width="this.settings['isMobileView'] ? 480 : 720"
    >
      <template slot="footer">
        <a-button key="back" type="primary" @click="handleCancel"
          >Close</a-button
        >
      </template>

      <div class="row">
        <div class="col-12 col-md-6">
          <p><span class="font-weight-bold">Sent On:</span> {{ data.created_at }}</p>
          <p><span class="font-weight-bold">Message:</span> {{data.message}}</p>
          <p><span class="font-weight-bold">Subject:</span> {{data.subject}}</p>
        </div>

        <div class="col-12 col-md-6">
          <p><span class="font-weight-bold">Class:</span> {{ data.school_class ? data.school_class.name : 'All' }} | Section: {{ data.section ? data.section.name : 'All' }}</p>
          <p><span class="font-weight-bold">Targets:</span> {{ ['student','teacher','guardian','father','mother'].filter(key => data[key] === 1).map(key => key.charAt(0).toUpperCase() + key.slice(1)).join(', ') }}</p>
          <p><span class="font-weight-bold">Types:</span> {{ ['sms','push','email','whatsapp'].filter(key => data[key] === 1).map(key => key.charAt(0).toUpperCase() + key.slice(1)).join(', ') }}</p>
          <p><span class="font-weight-bold">Recipients:</span> SMS {{ data.sms_recipients }} | Email {{ data.email_recipients }} | App {{ data.push_recipients }}</p>
        </div>
      </div>

      <hr />

      <div>
        <div class="row justify-content-between">
          <div class="col-12">
            <h5 class="card-title">
              <span class="text-gray-6">Notice Files</span>
            </h5>
                <ul class="list-group list-group-flush" v-if="data.school_notification_files">
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                    v-for="noticefile in data.school_notification_files"
                    :key="noticefile.id"
                  >
<!--                    <p class="mb-0">{{ homeworkfile.original_file_name }}</p>-->
                    <a :href="noticefile.file" target="_blank"><span class="fa fa-download"></span> {{noticefile.file.split('/').pop()}}</a>
                  </li>
                </ul>
          </div>
        </div>
      </div>

    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ViewNotice',
  data: function () {
    return {
      visible: false,
      loading: false,
      data: {},
    }
  },
  mounted: function () {
    this.$eventBus.$on('openViewForm', this.openModal)
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    openModal(record) {
      this.visible = true
      this.loading = true
      // this.$http.get(`/api/homework/single/${record.id}`)
      //   .then(data => {
      //     this.data = data.data.data
      //   })
      //   .catch(error => {
      //     console.error('API Error:', error)
      //   })
      this.data = record
    },
    handleCancel() {
      this.visible = false
    },

    handleDelete(data) {
      this.loading = true
      this.$confirm({
        title: 'Are you sure to delete this record?',
        content: 'Clicking yes will delete this homework.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/homework/' + data.id)
            .then((resp) => {
              if (resp.status === 200) {
                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: 'The homework has been deleted.',
                })
                this.visible = false
                this.$nprogress.done()
                this.$emit('updateTable') // Reload the table
                this.loading = true
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data. Please try again later.',
                })
                this.visible = false
                this.loading = false
                this.$emit('updateTable') // Reload the table
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
              this.visible = false
              this.loading = false
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
